module.exports = __webpack_public_path__ + "img/5befa5f.png";